import { useJournalStore } from '../hooks/useJournalStore';
import type { WidgetProps } from './WidgetRegistry';

export function CostTrackerWidget(_props: WidgetProps) {
  const journal = useJournalStore((s) => s.activeJournal);
  const events = useJournalStore((s) => s.liveEvents);

  if (!journal) return <div className="text-tower-muted text-sm p-3">No journal loaded</div>;

  const costEvents = events.filter(e => e.cost && e.cost.dollars > 0);
  const totalCost = journal.totalBudget.dollars.spent;
  const tierCosts = new Map<string, number>();
  for (const evt of costEvents) {
    const tier = (evt.payload?.tier as string) || 'unknown';
    tierCosts.set(tier, (tierCosts.get(tier) || 0) + (evt.cost?.dollars || 0));
  }

  const all = [journal.rootContinuation, ...journal.descendants];
  const topSpenders = [...all]
    .sort((a, b) => b.budget.dollars.spent - a.budget.dollars.spent)
    .slice(0, 5);

  return (
    <div className="p-3 space-y-3 text-xs">
      <div className="text-center">
        <div className="text-3xl font-mono font-bold text-tower-text">${totalCost.toFixed(2)}</div>
        <div className="text-tower-muted">Total Spend</div>
      </div>

      {tierCosts.size > 0 && (
        <div className="space-y-1">
          <div className="text-tower-muted">By Model Tier</div>
          {Array.from(tierCosts.entries()).map(([tier, cost]) => (
            <div key={tier} className="flex justify-between">
              <span className="text-tower-accent">{tier}</span>
              <span className="font-mono text-tower-text">${cost.toFixed(4)}</span>
            </div>
          ))}
        </div>
      )}

      <div className="border-t border-tower-border pt-2 space-y-1">
        <div className="text-tower-muted">Top Spenders</div>
        {topSpenders.map(c => (
          <div key={c.id} className="flex justify-between">
            <span className="text-tower-text truncate w-24">{c.goalFrame.intent}</span>
            <span className="font-mono text-tower-text">${c.budget.dollars.spent.toFixed(3)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
